import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function VasszerkezetiMunkak() {
  return (
    <SubPageLayout
      eyebrow="Vasszerkezeti munkák"
      title="Tartószerkezetek a ponyvához."
      intro="Egyedi acélvázas szerkezetek tervezése és gyártása sátrakhoz, terasztetőkhöz, mobilraktárakhoz. Statikailag méretezett, hegesztett kivitelben, helyszíni szereléssel."
      heroImage="/assets/gallery/egyedi-01.jpg"
      bullets={[
        { title: "Acélszerkezet", text: "A terhelés és környezet alapján méretezzük az anyagvastagságot." },
        { title: "Statikai méretezés", text: "Hó- és szélteher számítva – tartós, biztonságos szerkezet." },
        { title: "Hegesztett kivitel", text: "Folyamatos hegesztés, korrózióvédelem, festett vagy horganyzott." },
        { title: "Komplett kivitel", text: "Tervezés → gyártás → szerelés → ponyvázás egy helyen." },
      ]}
      gallery={SITE_IMAGES.ironGallery}
    />
  );
}
